import React, { Fragment, memo, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Dialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'
import LOG from '../../logging/Logger'

export const Confirm = memo(
  ({ title, message, onOk, onCancel, open, ...other }) => {
    LOG.debug('Render: Confirm')

    const handleEntering = useCallback(() => {}, [])

    const handleCancel = useCallback(() => {
      onCancel()
    }, [onCancel])

    const handleOk = useCallback(() => {
      onOk()
    }, [onOk])

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth='xs'
        onEntering={handleEntering}
        aria-labelledby='confirmation-dialog-title'
        open={open}
        {...other}
      >
        <DialogTitle id='confirmation-dialog-title'>{title}</DialogTitle>
        <DialogContent dividers>
          <Typography>{message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCancel} color='primary'>
            Cancel
          </Button>
          <Button onClick={handleOk} color='primary'>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
)

Confirm.propTypes = {
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
}

export default Confirm

export const ConfirmDelete = memo(
  ({ deleteItem, onOk, onCancel, open, trash = false }) => {
    LOG.debug('Render: ConfirmDelete')

    const message = useMemo(() => {
      return trash ? (
        <Typography component='span'>
          Are you sure you want to move{' '}
          <em>
            <b>{deleteItem}</b>
          </em>{' '}
          to Trash?
        </Typography>
      ) : (
        <Typography component='span'>
          Are you sure you want to delete{' '}
          <em>
            <b>{deleteItem}</b>
          </em>
          , this cannot be undone
        </Typography>
      )
    }, [deleteItem, trash])

    return (
      <Fragment>
        {/* The dialog should handle the open property, but I notice it flashes 'undefined' in the description before closing */}
        {open && (
          <Confirm
            onOk={onOk}
            onCancel={onCancel}
            open={open}
            title='Confirm Delete'
            message={message}
          />
        )}
      </Fragment>
    )
  }
)

ConfirmDelete.propTypes = {
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
}
